import { DrawerHeader, DrawerBody, DrawerFooter, IconButton, LoadingButton, Button, Card, Typography, NotificationBadge, } from '@one-thd/sui-atomic-components';
import { Close } from '@one-thd/sui-icons';
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { OOS_RECOVERY_OPTIONS, } from '../../../constants/out-of-stock';
import { getWindow } from '../../../utils/general';
import { useExperienceContext, useOrderContext, useFulfillmentGroupContext, } from '../../../hooks/useContexts';
import { UNAVAILABLE_IMAGE_URL } from '../../../constants/general';
import { getLineItemQuantity } from '../util/general';
export var BopisOutOfStockDrawerContent = function (_a) {
    var _b;
    var _c, _d, _e, _f;
    var setOpen = _a.setOpen, isOuterClick = _a.isOuterClick, setIsOuterClick = _a.setIsOuterClick;
    var fulfillmentGroup = useFulfillmentGroupContext().fulfillmentGroup;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var setCurrentDrawer = useOrderContext().setCurrentDrawer;
    var _g = useState(false), isSurvey = _g[0], setIsSurvey = _g[1];
    var _h = useState((_d = (_c = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.oosRecoveryOptions) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : ''), selectedOption = _h[0], setSelectedOption = _h[1];
    var closeDrawer = function () {
        // Reset outer click
        setIsOuterClick(false);
        setOpen(false);
    };
    var isIos = (_e = getWindow()) === null || _e === void 0 ? void 0 : _e.navigator.userAgent.includes('Mac');
    var isIosMobile = isIos && isConsumerApp;
    // Test once backend is ready
    var oosRecoveryOptions = (fulfillmentGroup.oosRecoveryOptions ||
        []);
    var oosRecoveryOptionsInfo = (_b = {},
        _b[OOS_RECOVERY_OPTIONS.STORE_PICKUP_OPTION] = {
            title: 'Pick up at a different store',
            description: 'Pick up your items at a different store that has your items in stock.',
        },
        _b[OOS_RECOVERY_OPTIONS.STH_DELIVERY_OPTION] = {
            title: 'Switch to delivery',
            description: 'Get your items delivered to you instead.',
        },
        _b);
    var renderOptions = function () {
        return oosRecoveryOptions === null || oosRecoveryOptions === void 0 ? void 0 : oosRecoveryOptions.map(function (option) {
            var _a, _b;
            return (React.createElement(Card, { key: option, grow: true, onClick: function () { return setSelectedOption(option); }, style: {
                    borderRadius: '4px',
                    boxShadow: 'none',
                    border: selectedOption === option ? '2px solid black' : '1px solid #BFBFBF',
                } },
                React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-2" },
                    React.createElement(Typography, { align: "left", weight: "bold", variant: "h4", height: "tight" }, (_a = oosRecoveryOptionsInfo[option]) === null || _a === void 0 ? void 0 : _a.title),
                    React.createElement(Typography, { align: "left" }, (_b = oosRecoveryOptionsInfo[option]) === null || _b === void 0 ? void 0 : _b.description))));
        });
    };
    var handleContinueClick = function () {
        setCurrentDrawer(selectedOption);
    };
    useEffect(function () {
        if (isOuterClick) {
            closeDrawer();
        }
    }, [isOuterClick]);
    return (React.createElement(React.Fragment, null,
        React.createElement(DrawerHeader, { title: "Review Your Options", endAdornment: React.createElement(IconButton, { "aria-label": "Close Review Your Options drawer", onClick: function () { return closeDrawer(); }, icon: Close, "data-testid": "bopis-out-of-stock-drawer-close-button" }) }),
        React.createElement(DrawerBody, null,
            React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4 sui-mt-2" }, oosRecoveryOptions.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "sui-flex sui-gap-5" }, (_f = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _f === void 0 ? void 0 : _f.map(function (item, index) { return (React.createElement(NotificationBadge, { key: index, variant: "strong", size: "small", color: "primary", badgeContent: getLineItemQuantity(item) },
                    React.createElement("img", { src: item.imageUrl || UNAVAILABLE_IMAGE_URL, height: 48, width: 48, alt: item.brandName, className: "sui-max-w-none img-height-fix" }))); })),
                renderOptions())))),
        React.createElement(DrawerFooter, { className: "sui-bg-primary sui-p-4 sui-relative sui-bottom-0 sui-sticky sui-shadow-sm" },
            React.createElement("div", { className: "sui-flex sui-flex-col sui-min-w-full sui-gap-2" },
                React.createElement("div", null,
                    React.createElement(LoadingButton, { style: { width: '100%' }, onClick: function () { return handleContinueClick(); } }, "Continue")),
                React.createElement("div", { className: classNames('card-fix', {
                        'ios-bottom-fix': isIosMobile,
                    }) },
                    React.createElement(Button, { variant: "secondary", style: { width: '100%' }, onClick: function () { return closeDrawer(); } }, "Cancel"))))));
};
